import { Component } from "react";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../../actions/fillCombo_action';
import { cityActionId, countryActionId, toastError, toastSuccess, industrySegmentListActionId, visitPurposeActionId, industryChaptersActionId } from "../../../../utils/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import { useNavigate } from "react-router-dom";
import ExhibitorDrawer from "../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import { insertUpdateIndustrySegmentMaster_action } from "../../../../actions/admin_module_action/master_action/industry_segment_master_action";


class IndustrySegmentMaster extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            industrySegmentList: [],
            isOpen: false,
            list: [],
            toAdd: false,
            ExhibitionID: '',
            loginAccesslist: []
        }
        // this.onDeleteRow = this.onDeleteRow.bind(this)
        this.onDelete = this.onDelete.bind(this)
        this.onAddRow = this.onAddRow.bind(this)
        this.getFillList = this.getFillList.bind(this)
        // this.getManualFormsMasterList = this.getManualFormsMasterList.bind(this)
        // this.addManualFormsMasterList = this.addManualFormsMasterList.bind(this)
        this.insertUpdateIndustrySegmentMasterList = this.insertUpdateIndustrySegmentMasterList.bind(this)
        this.onNameChange = this.onNameChange.bind(this)
    }

    componentDidMount() {
        this.setState({ loginAccesslist: JSON.parse(sessionStorage.getItem('loginDataSS'))['loginAccesslist'] })
        this.getFillList(industryChaptersActionId, '', '', '', '', '');
    }

    onAddRow(e) {
        e.preventDefault();
        // console.log(this.state.listLength)
        const { industrySegmentList } = this.state
        // var id = list.length + 1
        var map = {
            'Industrial Segment': "",
            IndustrySegmentID: null,
            isAdd: true,
            isUpdate: true,
        }
        industrySegmentList.push(map)
        this.setState({ industrySegmentList: industrySegmentList, })
        // console.log(this.state.StallSizeList)
    }

    // Get Fill Lists
    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
            .then((data) => {
                if (data.error != 1) {
                    // country list
                    if (actionID === industryChaptersActionId) {
                        console.log("country data", data.data)
                        data.data.map(item => {
                            // item.isAdd
                            item.isAdd = false
                            item.isUpdate = false
                        })
                        this.setState({ industrySegmentList: data.data, isLoading: false })
                    }
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    insertUpdateIndustrySegmentMasterList() {
        this.setState({ isLoading: true })
        const { industrySegmentList, ExhibitionID } = this.state
        console.log(industrySegmentList)

        var finalList = []
        for (var i = 0; i < industrySegmentList.length; i++) {
            if (industrySegmentList[i].isUpdate == true || industrySegmentList[i].isAdd == true) {
                finalList.push(industrySegmentList[i])
            }
        }
        var inputValidate = false
        for (var i = 0; i < finalList.length; i++) {
            if (finalList[i]['Industrial Segment'] == '' || finalList[i]['Industrial Segment'] == null) {
                inputValidate = true
                break
            }
        }
        if (inputValidate == true) {
            toastError("Please Fill all the Mandatory fields")
        }
        else {
            console.log(finalList)
            this.props.insertUpdateIndustrySegmentMaster_action(finalList)
                .then((data) => {
                    if (data.error != 1) {
                        this.setState({ isLoading: false })
                        // this.getManualFormsMasterList()
                        this.getFillList(industryChaptersActionId, '', '', '', '', '');
                        toastSuccess("update successfully")
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    }

    getWriteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '69');
        if (moduleAccess) {
            return moduleAccess.WriteAccess;
        } else {
            return false
        }
        return false;
    }

    getUpdateAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '69');
        if (moduleAccess) {
            return moduleAccess.UpdateAccess;
        } else {
            return false
        }
        return false;
    }

    getDeleteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '69');
        if (moduleAccess) {
            return moduleAccess.DeleteAccess;
        } else {
            return false
        }
        return false;
    }


    onDelete(i) {
        const { industrySegmentList, list } = this.state
        // var ManualFormMappingID = list[i].ManualFormMappingID
        if (industrySegmentList[i].isAdd == true) {
            industrySegmentList.splice(i, 1)
            this.setState({ industrySegmentList: industrySegmentList })
        }
        else {
            // this.setState({ isLoading: true })
            this.setState({ ManualFormMappingID: list[i].ManualFormMappingID })
            this.setState({ isOpen: true })

        }
    }

    // onDeleteRow() {
    //     const { ManualFormMappingID, ExhibitionID } = this.state
    //     this.props.deleteManualformsMaster_action(ExhibitionID, ManualFormMappingID)
    //         .then((data) => {
    //             if (data.error != 1) {
    //                 this.setState({ isOpen: false })
    //                 this.setState({ isLoading: false, list: [] })

    //                 this.setState({ isLoading: false })
    //                 toastSuccess("delete successfully")
    //                 this.getManualFormsMasterList()
    //             }
    //             else {
    //                 this.setState({ isLoading: false })
    //                 toastError(data.msg)
    //             }
    //         })
    //         .catch((err) => {
    //             console.log(err)
    //         })
    // }

    onNameChange(e, ID) {
        // e.preventDefault()
        const { industrySegmentList } = this.state
        console.log(e.target.value)
        industrySegmentList.map((data, i) => {
            if (ID == i) {
                data['Industrial Segment'] = e.target.value
                data.isUpdate = true
            }
        })
        // setTimeout(() => {
        console.log(industrySegmentList)
        this.setState({ industrySegmentList: industrySegmentList })
        // }, 200);
    }

    render() {
        const { isLoading, isOpen, list, industrySegmentList } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <div className="app-content with-dr-container com-height">
                        <AdminDrawer />
                        <div className="row m-0">
                            <div className="breadcrumb-scroll-fixed">
                                <h6 className="mb-0 p-2 text-white">Industry Segment List</h6>
                            </div>
                        </div>
                        <div className="main-container p-2 pt-0">
                            <div className="admin-top-space">
                                <div class="table-responsive mx-2 px-1 m-0 mt-2">
                                    <table class="table sticky-table text-nowrap table-bordered border-bottom border-1 mb-0">
                                        <thead class="table-light">
                                            <tr>
                                                <th style={{ width: '60px' }}>Sr No.</th>
                                                <th >Industry Segment<span style={{ color: 'red' }}>*</span></th>
                                                {this.getDeleteAccess() && <th style={{ width: '60px' }}></th>}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                industrySegmentList.length > 0 ? <>{
                                                    industrySegmentList.map((data, i) => (
                                                        <tr key={i}>
                                                            <td style={{ textAlign: 'center' }}>
                                                                {i + 1}
                                                            </td>
                                                            <td>
                                                                <input type="text" className="form-control" name="" value={data['Industrial Segment']}
                                                                    maxLength={'50'}
                                                                    onChange={(e) => this.onNameChange(e, i)}
                                                                />
                                                            </td>
                                                            {this.getDeleteAccess() && <td style={{ textAlign: 'center' }}>
                                                                <i className="fa fa-trash-o grid-icon"
                                                                    onClick={() => this.onDelete(i)}
                                                                />
                                                            </td>}

                                                        </tr>
                                                    ))}
                                                </> :
                                                    <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                            }
                                        </tbody>
                                    </table>
                                    <div className="text-end mt-2">
                                        <button type="button" class="btn btn-aqua" onClick={(e) => this.onAddRow(e)}>
                                            Add Row
                                        </button>
                                        <button disabled={list.length == 0 || !this.getWriteAccess()} type="button" class="btn btn-aqua ms-2"
                                            // disabled={}
                                            onClick={(e) => this.insertUpdateIndustrySegmentMasterList(e)}>
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>

                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog">
                        <div className="modal-content confirm-logout">
                            {/* <div class="modal-header text-right p-2">
                                <button type="button " class="close pop-close" data-dismiss="modal"
                                    onClick={() => this.setState({ isOpen: false })}
                                ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                            </div> */}
                            <div class="modal-body">
                                <div class="row">
                                    <h5 class="modal-title">Do you really want to delete this record?</h5>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-del-pop"
                                        onClick={(e) => this.onDeleteRow()}
                                    >Yes</button>
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isOpen: false })}
                                    >No</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal>
            </>
        )
    }
}

export default withRouter(connect(null, { fill_action, insertUpdateIndustrySegmentMaster_action })(IndustrySegmentMaster));